export const mapPhaseToMonths: Record<string, string> = {
  "tr-ot-1": "(Months 1-3)",
  "tr-ot-2": "(Months 4-6)",
  "tr-ot-3": "(Months 7-9)",
  "st-ot-1": "(Months 1-3)",
  "st-ot-2": "(Months 4-6)",
  "st-ot-3": "(Months 7-9)",
  "st-ot-4": "(Months 10-12)",
};
